function sortRecursively(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(sortRecursively)
  if (value && typeof value === 'object') {
    const obj = value as Record<string, unknown>
    const keys = Object.keys(obj).sort()
    const out: Record<string, unknown> = {}
    for (const k of keys) out[k] = sortRecursively(obj[k])
    return out
  }
  return value
}

function stableStringify(value: unknown): string {
  return JSON.stringify(sortRecursively(value))
}

// 仅做稳定序列化（键排序），接受任意结构以便复用于不同 digest 输入
export function digestEditor(payload: unknown): string {
  return stableStringify(payload)
}
